import { Template } from "@/@types/flows/emailTemplates";
import { CreateVariableDto } from "@/@types/flows/emailTemplates/dtos";
import { emailTemplateService } from "@/app/flows/emailTemplates/services/EmailTemplate.service";
import { cloneDeep } from "lodash";

class VariablesService {
  async create(template: Template, createVariableDto: CreateVariableDto) {
    const parameters = template.parameters || [];

    await emailTemplateService.update(template.id, {
      parameters: [...parameters, createVariableDto],
    });
  }

  async edit(template: Template, idx: number, editVariableDto: CreateVariableDto) {
    const parameters = cloneDeep(template.parameters);

    parameters.splice(idx, 1, editVariableDto);

    await emailTemplateService.update(template.id, { parameters });
  }

  async delete(template: Template, idx: number) {
    const parameters = cloneDeep(template.parameters);

    parameters.splice(idx, 1);

    await emailTemplateService.update(template.id, { parameters });
  }
}

export const variablesService = new VariablesService();
